module.exports = __webpack_public_path__ + "manager/img/icon-error.532aac9.png";